import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import moment from "moment";

export const TimeoutLogic = ({ session, setSession }) => {
    const [isWarningModalOpen, setWarningModalOpen] = useState(false);
    const [isLogoutModalOpen, setLogoutModalOpen] = useState(false);
    const [second, setSecond] = useState(60);
    useEffect(() => {



        const createTimeout1 = () => setTimeout(() => {
            interval = intervalInactive();


        }, 1000);

        const intervalEmpty = () => { }
        const intervalInactive = () => setInterval(() => {
            let cliente = sessionStorage.getItem("cliente")
            let videoActive = sessionStorage.getItem("videoActive")

            // console.log("cliente", cliente, "videoActive", videoActive)
            if (cliente && !videoActive) {
                const popTime = 10; // minutes of inactivity before showing the warning modal

                let timeString = sessionStorage.getItem('lastTimeStamp');
                const diff = moment.duration(moment().diff(moment(timeString)));
                const minPast = diff.minutes();

                if (minPast === popTime) {
                    setWarningModalOpen(true);
                }



                // setWarningModalOpen(true);

            }
        }, 5000)
        const createTimeout2 = () => setInterval(() => {


            let timeString = sessionStorage.getItem('lastTimeStamp');
            const diff = moment.duration(moment().diff(moment(timeString)));

            const leftSecond = 60 - diff.seconds();

            setSecond(leftSecond);

            if (leftSecond === 1) {
                sessionStorage.removeItem('lastTimeStamp');
                sessionStorage.removeItem('cliente');
                sessionStorage.removeItem('nombre');
                // sessionStorage.clear();
                interval = intervalEmpty();
                setWarningModalOpen(false);

                setLogoutModalOpen(true)
                window.sessionStorage.setItem('LogOutAlert', "true");
                // console.log("logout")
                setSession(false)
            }

        }, 1000)

        const listener = () => {
            if (!isWarningModalOpen) {
                clearTimeout(timeout);
                clearInterval(interval);
                timeout = createTimeout1();
                interval = null;
                interval = intervalInactive();
                let timeStamp = moment();
                sessionStorage.setItem('lastTimeStamp', timeStamp);
            }
        }

        // Initialization
        let timeout = isWarningModalOpen ? createTimeout2() : createTimeout1();
        let interval = !isWarningModalOpen ? intervalInactive() : intervalEmpty();

        let cliente = sessionStorage.getItem("cliente")
        if (cliente) {
            addEventListeners(listener);
        }
        // Cleanup
        return () => {
            removeEventListeners(listener);
            clearTimeout(timeout);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isWarningModalOpen, session])

    return (
        <div>
            {isWarningModalOpen && (
                <TimeoutWarningModal
                    second={second}
                    type={"warning"}
                    isOpen={isWarningModalOpen}
                    onRequestClose={() => setWarningModalOpen(false)}
                    setLogoutModalOpen={setLogoutModalOpen}
                    setSession={setSession}
                    setWarningModalOpen={setWarningModalOpen}
                />
            )
            }
            {isLogoutModalOpen && (
                <TimeoutWarningModal
                    // second={second}
                    type={"logout"}
                    isOpen={isLogoutModalOpen}
                    onRequestClose={() => {
                        setLogoutModalOpen(false);
                    }}

                />
            )
            }
        </div>
    )
}


const TimeoutWarningModal = ({ isOpen, onRequestClose, second, type, setWarningModalOpen, setLogoutModalOpen, setSession }) => {
    const onLogOffCall = () => {

        sessionStorage.removeItem('lastTimeStamp');
        sessionStorage.removeItem('cliente');
        sessionStorage.removeItem('nombre');
        localStorage.clear();
        // sessionStorage.clear();
        // interval = intervalEmpty();
        setWarningModalOpen(false);

        setLogoutModalOpen(true);
        window.sessionStorage.setItem('LogOutAlert', "true");
        setSession(false);
    }

    useEffect(() => {
        if (type === "logout") {
            sessionStorage.removeItem('LogOutAlert');
        }
    }, [type])

    return (
        <div>
          
            <Dialog
                open={isOpen}
                // onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="alertIndex"
            >
                <DialogTitle id="alert-dialog-title">
                    Sesión inactiva.
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" style={{ fontSize: "20px", fontFamily: "Lato, sans serif", color: "#000" }}>
                        {type === "warning" &&
                            `La sesión finalizara en ${second} segundos.`
                        }
                        {type === "logout" &&
                            `La sesión finalizó por inactividad.`
                        }
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={ type === "warning"  ? {justifyContent: "space-evenly", marginBottom: "15px"} : {justifyContent: "center", marginBottom: "15px"}}>

                    {type === "warning" &&
                        <React.Fragment>

                            <Button className='btnAlert' onClick={onLogOffCall}>Cerrar sesión</Button>
                            <Button className='btnAlert' style={{background: "var(--primary)", color: "#FFFFFF"}}  onClick={onRequestClose}>Mantener sesión</Button>
                        </React.Fragment>
                    }
                    {type === "logout" &&
                        <Button className='btnAlert' style={{background: "var(--primary)", color: "#FFFFFF"}}  onClick={onRequestClose}>Aceptar </Button>

                    }

                </DialogActions>
            </Dialog>
        </div>
    );
}


const eventTypes = [
    'keypress',
    'mousemove',
    'mousedown',
    'scroll',
    'click',
    'load',
    'touchmove',
    'pointermove'
]
const addEventListeners = (listener) => {
    eventTypes.forEach((type) => {
        document.addEventListener(type, listener, false)
    })

}
const removeEventListeners = (listener) => {
    if (listener) {
        eventTypes.forEach((type) => {
            document.removeEventListener(type, listener, false)
        })

    }
}